import { find } from 'lodash/fp';
import { PATH_BUILDER } from 'constants/actionTypes';
import { EVENTS } from 'constants/config';
import {
  updateItem,
  reorderItem,
  removeAndUpdatePositions,
  resetPositions,
  hasOwnProperty,
} from 'utils/fp';

const pathContentReducer = (state = [], { type, ...action }, newState) => {
  global.pubsub.publish(EVENTS.SET_STEP_CONNECTOR_POSITION);
  switch (type) {
    case PATH_BUILDER.CONTENT.UPDATE:
      return updateItem(
        state,
        { id: action.id, type: action.contentType },
        action.changes,
        false,
      );

    case PATH_BUILDER.CONTENT.ADD: {
      const { contentType, position, ...rest } = action;
      const index = position - 1;
      return resetPositions([
        ...state.slice(0, index),
        { type: contentType, position, ...rest },
        ...state.slice(index),
      ]);
    }

    case PATH_BUILDER.CONTENT.PERSIST: {
      const predicate = { id: action.id, type: action.contentType };
      return updateItem(state, predicate, { justAdded: false }, false);
    }

    case PATH_BUILDER.CONTENT.REMOVE:
      return removeAndUpdatePositions(action.id, action.contentType)(state);

    case PATH_BUILDER.CONTENT.REORDER: {
      const { position, newPosition } = action;
      const newItems = reorderItem(position, newPosition)(state);
      return newItems;
    }

    case PATH_BUILDER.PATH.RESTORE_REVISION: {
      return newState.map(revisionContent => {
        const identity = { id: revisionContent.id, type: revisionContent.type };
        const currentContent = find(identity, state);
        /**
         * since we're merging two objects, we omit some of the keys if they
         * exist in currentContent but not revisionContent
         */
        const OMIT_MERGE_KEYS = ['dueIn'];
        OMIT_MERGE_KEYS.forEach(property => {
          if (
            !hasOwnProperty(revisionContent, property) &&
            hasOwnProperty(currentContent, property)
          ) {
            delete currentContent[property];
          }
        });
        // merging two objects currentContent if exists, and revisionContent
        return { ...currentContent, ...revisionContent };
      });
    }

    default:
      return state;
  }
};

export default pathContentReducer;
